<div class="progress-bar-track"
     [attr.data-testid]="trackTestId"
     [attr.data-actual]="actual"
     [attr.data-target]="target"
     [attr.data-marker-pct]="layout.markerPct"
     [title]="title || null">
    <div class="progress-bar-fill"
         [class.tone-over]="tone === 'over'"
         [class.tone-under]="tone === 'under'"
         [class.tone-ok]="tone === 'ok'"
         [class.tone-unknown]="tone === 'unknown'"
         [class.tone-neutral]="tone === 'neutral'"
         [attr.data-testid]="fillTestId"
         [attr.data-fill-pct]="layout.fillPct"
         [style.width.%]="layout.fillPct">
    </div>
    <div *ngIf="markerVisible"
         class="progress-bar-marker"
         [attr.data-testid]="markerTestId"
         [style.left.%]="layout.markerPct">
    </div>
</div>
